(() => {
  const overlays = () => [...document.querySelectorAll('.flux-overlay-details')];
  const focusable = (details) => [...details.querySelectorAll('a[href], button, input:not([type="hidden"]), select, textarea, [tabindex="0"]')].filter((element) => !element.disabled && element.getClientRects().length);
  const syncScrollLock = () => document.documentElement.classList.toggle('flux-overlay-open', overlays().some((details) => details.open));
  const closeOverlay = (details, restoreFocus = true) => {
    details.open = false;
    syncScrollLock();
    if (restoreFocus) details.querySelector('summary')?.focus({ preventScroll: true });
  };
  const bindOverlays = () => {
    for (const details of overlays()) {
      if (details.dataset.vividlyBound) continue;
      details.dataset.vividlyBound = 'true';
      details.addEventListener('toggle', () => {
        if (details.open) {
          for (const other of overlays()) if (other !== details && other.open) closeOverlay(other, false);
          requestAnimationFrame(() => {
            if (!details.open) return;
            (details.querySelector('input[type="search"]') ?? details.querySelector('[data-flux-close-overlay]'))?.focus({ preventScroll: true });
          });
        }
        syncScrollLock();
      });
    }
  };
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const closeButton = event.target.closest('[data-flux-close-overlay]');
    if (closeButton) {
      const details = closeButton.closest('.flux-overlay-details');
      if (details) closeOverlay(details);
      return;
    }
    const bagLink = event.target.closest('[data-vividly-open-bag]');
    if (!bagLink || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const drawer = document.getElementById('cart-drawer');
    if (typeof drawer?.open !== 'function') return;
    event.preventDefault();
    for (const details of overlays()) if (details.open) closeOverlay(details, false);
    drawer.open();
  });
  document.addEventListener('keydown', (event) => {
    const openDetails = overlays().find((details) => details.open);
    if (!openDetails) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeOverlay(openDetails);
      return;
    }
    if (event.key !== 'Tab') return;
    const elements = focusable(openDetails);
    const first = elements[0];
    const last = elements.at(-1);
    if (!first) return;
    if (event.shiftKey && (document.activeElement === first || !openDetails.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !openDetails.contains(document.activeElement))) {
      event.preventDefault();
      first.focus();
    }
  });
  let countRevision = 0;
  document.addEventListener('shopify:cart:lines-update', async (event) => {
    const revision = ++countRevision;
    try {
      const result = await event.promise;
      let count = result?.cart?.totalQuantity ?? result?.detail?.itemCount;
      if (!Number.isFinite(count)) {
        const root = window.Shopify?.routes?.root ?? '/';
        const response = await fetch(`${root}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        count = (await response.json()).item_count;
      }
      if (revision !== countRevision || !Number.isFinite(count)) return;
      for (const element of document.querySelectorAll('[data-flux-cart-count]')) element.textContent = String(count);
    } catch {}
  });
  if (document.readyState === 'loading') {
    const readinessObserver = new MutationObserver(bindOverlays);
    readinessObserver.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('DOMContentLoaded', () => {
      bindOverlays();
      readinessObserver.disconnect();
    }, { once: true });
  }
  bindOverlays();
  document.addEventListener('shopify:section:load', bindOverlays);
})();
